import { CameraGroupPayload } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateCameraGroup(
  cameraGroupId: string,
  onSuccess?: () => void,
  onError?: () => void
) {
  const url = `/v2/orm/camera_groups/${cameraGroupId}`;

  const request = new Request(url, {
    method: 'PATCH',
  });

  return useAuthenticatedMutation<null, CameraGroupPayload | null>(request, {
    onSuccessInvalidationKeys: [['camera-groups']],
    onSuccess,
    onError,
  });
}

export default useUpdateCameraGroup;
